import React from 'react';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <section className="bg-white px-5 py-14 md:py-24" data-id="element-108" data-mp="1o3x3nprb6w3l">
      <div className="max-w-3xl mx-auto border border-gray-200 border-t-4 border-t-neon px-5 py-10 md:px-14 md:py-16 text-center" data-id="element-109" data-mp="1o3dlq91ns7pk">
        <span className="inline-flex w-16 h-16 md:w-20 md:h-20 rounded-full bg-neon/15 text-neon-deep items-center justify-center mb-5 md:mb-7" data-id="element-110" data-mp="1x4bqwunu2l9q">
          <ShieldCheck size={38} aria-hidden="true" data-id="element-111" data-mp="19fit0snni3ch" />
        </span>

        <h2 className="font-display uppercase text-gray-900 text-[7vw] min-[430px]:text-2xl md:text-4xl leading-tight mb-4 md:mb-6" data-id="element-112" data-mp="14g67cb8in2bh">
          7-day money-back{' '}
          <span className="text-neon-deep" data-id="element-113" data-mp="1j6n43ha7h421">guarantee.</span>
        </h2>

        <p className="text-gray-600 text-sm md:text-lg leading-relaxed max-w-xl mx-auto mb-6 md:mb-8" data-id="element-114" data-mp="1ec98bdrmsuwu">
          Open all 14 volumes. Go through the 6 bonuses. Use them on your field.
          If it is not what you expected, you get a 100% refund. No questions.
          No forms. No hassle.
        </p>

        <span className="inline-block bg-gray-100 text-gray-700 text-[0.65rem] md:text-xs font-bold uppercase tracking-[0.14em] px-4 py-2 md:px-5 md:py-2.5" data-id="element-115" data-mp="oz9kct34oxhv">
          Refund rate under 2%
        </span>
      </div>
    </section>;
}